import confianceImg from "../images/confiance.jpg";
import franceImg from "../images/france.jpg";
import belgiqueImg from "../images/belgique.jpg";
import canadaImg from "../images/canada.jpg";
import luxembourgImg from "../images/luxembourg.jpg";
import studentsImg from "../images/students.jpg";
import studentImg from "../images/student.jpg";
import accueilImg from "../images/accueil.jpg";
import serviceImg from "../images/service.jpg";
import destinationImg from "../images/destination.jpg";
import travelImg from "../images/travel.jpg";
import contactImg from "../images/contact.jpg";

export const IMAGES = {
  confianceImg: confianceImg,
  franceImg: franceImg,
  belgiqueImg: belgiqueImg,
  canadaImg: canadaImg,
  luxembourgImg: luxembourgImg,
  studentsImg: studentsImg,
  studentImg: studentImg,
  accueilImg: accueilImg,
  serviceImg: serviceImg,
  destinationImg: destinationImg,
  travelImg: travelImg,
  contactImg: contactImg,
};
